export default "__VITE_ASSET__8387574f__"